import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useBaseTecnicaSection } from "./use-base-tecnica-section";
import { BaseTecnicaSectionView } from "./view-base-tecnica-section";

export function BaseTecnicaSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useBaseTecnicaSection(props);

  return <BaseTecnicaSectionView {...vm} />;
}

export type * from "./types-base-tecnica-section";
